<template>
    <div class="industry">
      <banner clazz="industry-banner" url="Industry">
      </banner>
      <div class="industry-list">
        <div class="w1200 tc">
          <h1 class="titleName">选择您的行业，了解采购方案</h1>
          <div class="dib border-bottom"></div>
          <ul class="clearfix industry-ul">
            <li v-for="(item, index) in dataList">
              <a class="industry-w db" :href="goDetail(item.name, item.id)">
                <div class="dib industry-img">
                  <!--<img v-lazy="require('../../assets/img/industry/industry' + (index + 1) + '.svg')">-->
                  <img v-lazy="$global.globalPath + item.src" :alt="item.name">
                </div>
                <h2 class="title">{{item.name}}</h2>
                <div class="tl desc">{{item.content}}</div>
                <div class="look-detail">
                  <span>查看详情  ></span>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
</template>

<script>
import banner from '../common/banner.vue'
import solutionIndex from '../../assets/js/solutionIndex.json'

export default {
  name: 'Industry',
  components: {
    banner
  },
  data () {
    return {
      dataList: this.$store.state.solutionList || [],
      solutionIndex: solutionIndex.data
    }
  },
  methods: {
    getListData () {
      this.$api.post('/solution/Solution_list', {}, (r) => {
        if (r.code === 0) {
          this.dataList = r.data
        } else {
          this.$message.error(r.message)
        }
      })
    },
    goDetail (str, id) {
      let routeUrl = ''
      let solution = this.solutionIndex.find((item) => {
        return item.name === str
      })
      if (solution) {
        routeUrl = this.$router.resolve({
          path: '/solution/' + solution.code
        })
      } else {
        routeUrl = this.$router.resolve({
          name: 'NotFound'
        })
      }
      let result = this.$global.frontPath + routeUrl.href
      return result
      //        this.$router.push({
      //          name: 'Solution',
      //          query: {
      //            id: id
      //          }
      //        })
    }
  },
  mounted () {
    if (!this.dataList.length) {
      this.getListData()
    }
  }
}
</script>

<style lang="scss">
@import "../../../static/css/industry.scss";
</style>



// WEBPACK FOOTER //
// industry.vue?6a59af14